// test480
(480 && 0);
